import { useGetTeamDataManagementBillingQuery } from 'store/apis/teamsApi';
import { StatusLabels } from 'components/TeamOverview/BillingSection/utilities/utilities';
import { transformDataUsage } from 'components/UserProfile/utilities';
import { MB } from 'components/UserProfile/constants';
import { useQueryError } from 'utilities/hooks/useQueryError/useQueryError';
import { FETCH_TEAMS_DATA_MANAGEMENT_BILLINGS_ERROR } from 'constants/errorMessages';

export const useBlocksStorageBilling = (team) => {
  const {
    data,
    error,
    isFetching: isLoading,
  } = useGetTeamDataManagementBillingQuery(
    {
      teamUUID: team?.uuid,
    },
    {
      skip: !team?.uuid,
    },
  );

  useQueryError(error, FETCH_TEAMS_DATA_MANAGEMENT_BILLINGS_ERROR);

  const parsedBilling = data
    ? data.map((blocksBilling) => {
      const {
        project,
        order,
        status,
        billable_slides_storage_mb,
        fulfilled_date,
        next_billing_date,
      } = blocksBilling;

      return {
        project,
        orderId: order.id,
        orderUUID: order.uuid,
        statusLabel: StatusLabels[status],
        dataUsed: transformDataUsage(billable_slides_storage_mb, MB),
        status,
        fulfilledDate: fulfilled_date,
        nextBillingDate: next_billing_date,
      };
    })
    : [];

  return {
    billings: parsedBilling,
    isLoading,
  };
};
